<template>
  <div class="container my-5">
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-10">
        <div v-if="company && company.config != null && showLogo" class="text-center mb-4">
          <img
            class="logo-page custom-privacy-logo"
            :src="companyLogo"
            alt=""
          />
        </div>
        <div v-if="contentLoaded" v-html="customHtml" class="my-5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import companyMixin from "@state/company";
import { useConfiguration } from "@state/user/configuration";

export default {
  mixins: [companyMixin],
  setup() {
    const configuration = useConfiguration();
    return {
      configuration,
    };
  },
  data() {
    return {
      customHtml: null,
      contentLoaded: false,
    };
  },
  computed: {
    showLogo() {
      return (
        ["default", "normal-square"].indexOf(
          this.company?.config?.logo_position
        ) !== -1
      );
    },
    companyLogo() {
      if (!this.company?.config) return "";
      if (this.company.config.logo_position === "default") {
        return this.company?.config?.menu?.logo || "";
      }
      return this.company?.config?.menu?.square_logo || "";
    },
  },
  created() {
    this.configuration.getCustomPrivacyPolicy().then((response) => {
      this.customHtml = response.data || null;
      this.contentLoaded = true;
    }).catch(() => {
      this.contentLoaded = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.custom-privacy-logo {
  max-height: 2.5rem;
}
</style>
